var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    : _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "column col-margin" },
            [
              _c("div", { staticClass: "submit query" }, [
                _c(
                  "button",
                  {
                    staticClass: "button btn btn-sm btn-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.submitQuery }
                  },
                  [_vm._v("Submit Query")]
                )
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "title-heading" }, [
                _vm._v("Insights Tester")
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "sub-heading" }, [_vm._v("Query")]),
              _vm._v(" "),
              _c("div", [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.query,
                      expression: "query"
                    }
                  ],
                  staticClass: "input-field",
                  domProps: { value: _vm.query },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.query = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("Transition", { attrs: { name: "response", appear: "" } }, [
                _vm.retrieving || _vm.response
                  ? _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.response,
                          expression: "response"
                        }
                      ],
                      class: {
                        response: !_vm.retrieving,
                        retrieving: _vm.retrieving
                      },
                      attrs: { readonly: "" },
                      domProps: { value: _vm.response },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.response = $event.target.value
                        }
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "submit instruction" }, [
                _c(
                  "button",
                  {
                    staticClass: "button btn btn-sm btn-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.submitInstructions }
                  },
                  [_vm._v("Update Instructions")]
                )
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "sub-heading" }, [_vm._v("Supervisor")]),
              _vm._v(" "),
              _c("div", [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.supervisor,
                      expression: "supervisor"
                    }
                  ],
                  staticClass: "input-field",
                  domProps: { value: _vm.supervisor },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.supervisor = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "sub-heading" }, [_vm._v("Costs")]),
              _vm._v(" "),
              _c("div", [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.costs,
                      expression: "costs"
                    }
                  ],
                  staticClass: "input-field",
                  domProps: { value: _vm.costs },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.costs = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "sub-heading" }, [_vm._v("Deployments")]),
              _vm._v(" "),
              _c("div", [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.deployments,
                      expression: "deployments"
                    }
                  ],
                  staticClass: "input-field",
                  domProps: { value: _vm.deployments },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.deployments = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid grid-cols-1 mt-8 gap-4" },
                [
                  _c(
                    "Card",
                    { attrs: { title: "Widget Tester" } },
                    [
                      _c("InsightsDateFilters", {
                        on: { update: _vm.updateAllWidgets },
                        model: {
                          value: _vm.selectedDate,
                          callback: function($$v) {
                            _vm.selectedDate = $$v
                          },
                          expression: "selectedDate"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-between cursor-pointer",
                          on: {
                            click: function($event) {
                              _vm.alertsOpen = !_vm.alertsOpen
                            }
                          }
                        },
                        [
                          _c("h5", { staticClass: "sub-heading" }, [
                            _vm._v("Alerts Test")
                          ]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "w-4 h-4 transition-transform",
                              class: { "rotate-180": _vm.alertsOpen },
                              attrs: {
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 9l-7 7-7-7"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Transition",
                        { attrs: { name: "response", appear: "" } },
                        [
                          _vm.alertsOpen
                            ? _c("div", { staticClass: "mt-2" }, [
                                _vm.alertsRetrieving || _vm.alertsResponse
                                  ? _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.alertsResponse,
                                          expression: "alertsResponse"
                                        }
                                      ],
                                      class: {
                                        response: !_vm.alertsRetrieving,
                                        retrieving: _vm.alertsRetrieving
                                      },
                                      attrs: { readonly: "" },
                                      domProps: { value: _vm.alertsResponse },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.alertsResponse =
                                            $event.target.value
                                        }
                                      }
                                    })
                                  : _c(
                                      "textarea",
                                      { attrs: { readonly: "" } },
                                      [_vm._v("Loading...")]
                                    )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-between cursor-pointer",
                          on: {
                            click: function($event) {
                              _vm.deploymentsOpen = !_vm.deploymentsOpen
                            }
                          }
                        },
                        [
                          _c("h5", { staticClass: "sub-heading" }, [
                            _vm._v("Deployments Test")
                          ]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "w-4 h-4 transition-transform",
                              class: { "rotate-180": _vm.deploymentsOpen },
                              attrs: {
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 9l-7 7-7-7"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Transition",
                        { attrs: { name: "deploymentResponse", appear: "" } },
                        [
                          _vm.deploymentsOpen
                            ? _c("div", { staticClass: "mt-2" }, [
                                _vm.deploymentsRetrieving ||
                                _vm.deploymentsResponse
                                  ? _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.deploymentsResponse,
                                          expression: "deploymentsResponse"
                                        }
                                      ],
                                      class: {
                                        response: !_vm.deploymentsRetrieving,
                                        retrieving: _vm.deploymentsRetrieving
                                      },
                                      attrs: { readonly: "" },
                                      domProps: {
                                        value: _vm.deploymentsResponse
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.deploymentsResponse =
                                            $event.target.value
                                        }
                                      }
                                    })
                                  : _c(
                                      "textarea",
                                      { attrs: { readonly: "" } },
                                      [_vm._v("Loading...")]
                                    )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-between cursor-pointer",
                          on: {
                            click: function($event) {
                              _vm.costsOpen = !_vm.costsOpen
                            }
                          }
                        },
                        [
                          _c("h5", { staticClass: "sub-heading" }, [
                            _vm._v("Costs Test")
                          ]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "w-4 h-4 transition-transform",
                              class: { "rotate-180": _vm.costsOpen },
                              attrs: {
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 9l-7 7-7-7"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Transition",
                        { attrs: { name: "costsResponse", appear: "" } },
                        [
                          _vm.costsOpen
                            ? _c("div", { staticClass: "mt-2" }, [
                                _vm.costsRetrieving || _vm.costsResponse
                                  ? _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.costsResponse,
                                          expression: "costsResponse"
                                        }
                                      ],
                                      class: {
                                        response: !_vm.costsRetrieving,
                                        retrieving: _vm.costsRetrieving
                                      },
                                      attrs: { readonly: "" },
                                      domProps: { value: _vm.costsResponse },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.costsResponse =
                                            $event.target.value
                                        }
                                      }
                                    })
                                  : _c(
                                      "textarea",
                                      { attrs: { readonly: "" } },
                                      [_vm._v("Loading...")]
                                    )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-between cursor-pointer",
                          on: {
                            click: function($event) {
                              _vm.base2summaryOpen = !_vm.base2summaryOpen
                            }
                          }
                        },
                        [
                          _c("h5", { staticClass: "sub-heading" }, [
                            _vm._v("Time Series Summary Test")
                          ]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "w-4 h-4 transition-transform",
                              class: { "rotate-180": _vm.base2summaryOpen },
                              attrs: {
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 9l-7 7-7-7"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Transition",
                        { attrs: { name: "base2summaryResponse", appear: "" } },
                        [
                          _vm.base2summaryOpen
                            ? _c("div", { staticClass: "mt-2" }, [
                                _vm.base2summaryRetrieving ||
                                _vm.base2summaryResponse
                                  ? _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.base2summaryResponse,
                                          expression: "base2summaryResponse"
                                        }
                                      ],
                                      class: {
                                        response: !_vm.base2summaryRetrieving,
                                        retrieving: _vm.base2summaryRetrieving
                                      },
                                      attrs: { readonly: "" },
                                      domProps: {
                                        value: _vm.base2summaryResponse
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.base2summaryResponse =
                                            $event.target.value
                                        }
                                      }
                                    })
                                  : _c(
                                      "textarea",
                                      { attrs: { readonly: "" } },
                                      [_vm._v("Loading...")]
                                    )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-between cursor-pointer",
                          on: {
                            click: function($event) {
                              _vm.widget1Open = !_vm.widget1Open
                            }
                          }
                        },
                        [
                          _c("h5", { staticClass: "sub-heading" }, [
                            _vm._v("Widget 1 Test")
                          ]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "w-4 h-4 transition-transform",
                              class: { "rotate-180": _vm.widget1Open },
                              attrs: {
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 9l-7 7-7-7"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Transition",
                        { attrs: { name: "widget1Response", appear: "" } },
                        [
                          _vm.widget1Open
                            ? _c("div", { staticClass: "mt-2" }, [
                                _vm.widget1Retrieving || _vm.widget1Response
                                  ? _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.widget1Response,
                                          expression: "widget1Response"
                                        }
                                      ],
                                      class: {
                                        response: !_vm.widget1Retrieving,
                                        retrieving: _vm.widget1Retrieving
                                      },
                                      attrs: { readonly: "" },
                                      domProps: { value: _vm.widget1Response },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.widget1Response =
                                            $event.target.value
                                        }
                                      }
                                    })
                                  : _c(
                                      "textarea",
                                      { attrs: { readonly: "" } },
                                      [_vm._v("Loading...")]
                                    )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-between cursor-pointer",
                          on: {
                            click: function($event) {
                              _vm.widget2Open = !_vm.widget2Open
                            }
                          }
                        },
                        [
                          _c("h5", { staticClass: "sub-heading" }, [
                            _vm._v("Widget 2 Test")
                          ]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "w-4 h-4 transition-transform",
                              class: { "rotate-180": _vm.widget2Open },
                              attrs: {
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 9l-7 7-7-7"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Transition",
                        { attrs: { name: "widget2Response", appear: "" } },
                        [
                          _vm.widget2Open
                            ? _c("div", { staticClass: "mt-2" }, [
                                _vm.widget2Retrieving || _vm.widget2Response
                                  ? _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.widget2Response,
                                          expression: "widget2Response"
                                        }
                                      ],
                                      class: {
                                        response: !_vm.widget2Retrieving,
                                        retrieving: _vm.widget2Retrieving
                                      },
                                      attrs: { readonly: "" },
                                      domProps: { value: _vm.widget2Response },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.widget2Response =
                                            $event.target.value
                                        }
                                      }
                                    })
                                  : _c(
                                      "textarea",
                                      { attrs: { readonly: "" } },
                                      [_vm._v("Loading...")]
                                    )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-between cursor-pointer",
                          on: {
                            click: function($event) {
                              _vm.widget3Open = !_vm.widget3Open
                            }
                          }
                        },
                        [
                          _c("h5", { staticClass: "sub-heading" }, [
                            _vm._v("Widget 3 Test")
                          ]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "w-4 h-4 transition-transform",
                              class: { "rotate-180": _vm.widget3Open },
                              attrs: {
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 9l-7 7-7-7"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Transition",
                        { attrs: { name: "widget3Response", appear: "" } },
                        [
                          _vm.widget3Open
                            ? _c("div", { staticClass: "mt-2" }, [
                                _vm.widget3Retrieving || _vm.widget3Response
                                  ? _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.widget3Response,
                                          expression: "widget3Response"
                                        }
                                      ],
                                      class: {
                                        response: !_vm.widget3Retrieving,
                                        retrieving: _vm.widget3Retrieving
                                      },
                                      attrs: { readonly: "" },
                                      domProps: { value: _vm.widget3Response },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.widget3Response =
                                            $event.target.value
                                        }
                                      }
                                    })
                                  : _c(
                                      "textarea",
                                      { attrs: { readonly: "" } },
                                      [_vm._v("Loading...")]
                                    )
                              ])
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f333e798", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f333e798","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/InsightsTester.vue
// module id = null
// module chunks = 